// extracted by mini-css-extract-plugin
module.exports = {"nav":"MainNavigation_nav__2KJfX","active":"MainNavigation_active__oN3Ka"};